import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { Ionic2Rating } from './ratingComponent/rating.component';

const IONIC2_RATING_DIRECTIVES = [Ionic2Rating];

@NgModule({
  imports: [IonicModule],
  declarations: IONIC2_RATING_DIRECTIVES,
  exports: IONIC2_RATING_DIRECTIVES
})
export class UiCommonModule {}


// WEBPACK FOOTER //
// ./src/app/shared/ui/ui.common.module.ts